import styled from "styled-components";

export const StyledScrollY = styled.div`
    overflow-y: scroll;
    overflow-x: hidden;
`;